import { FC } from "react";
import SearchArticles from "./SearchArticles/SearchArticles";
import styles from "./SearchDropDown.module.scss";
import SearchProducts from "./SearchProducts/SearchProducts";
import SearchSuggestions from "./SearchSuggestions/SearchSuggestions";
import type { SearchDropdownDataType } from "../SearchBar";
import { ProductData } from "@/lib/5874/types";

interface searchDropDownProps {
	datalayerProducts?: ProductData[] | undefined;
	searchEntry: string;
	searchDropdownData: SearchDropdownDataType;
	handleSuggestionClick: (suggestion: string) => void;
	handleCloseClick: () => void;
}

const SearchDropDown: FC<searchDropDownProps> = ({
	datalayerProducts,
	searchEntry,
	searchDropdownData,
	handleSuggestionClick,
	handleCloseClick,
}) => {
	const { products, articles, suggestions } = searchDropdownData;

	return (
		<div className={styles.searchDropDown}>
			<SearchSuggestions
				isLoading={suggestions.isLoading}
				searchEntry={searchEntry}
				suggestions={suggestions.result}
				manageSuggestionClick={handleSuggestionClick}
				manageCloseDropDown={handleCloseClick}
				maxLimit={4}
			/>
			<div className={styles.bottom}>
				<SearchProducts
					datalayerProducts={datalayerProducts}
					products={products.result}
					manageCloseDropdown={handleCloseClick}
					maxLimit={6}
					isLoading={products.isLoading}
					searchTerm={searchEntry}
				/>
				<SearchArticles
					articles={articles.result}
					manageArticleClick={handleCloseClick}
					maxLimit={3}
					isLoading={articles.isLoading}
					searchTerm={searchEntry}
				/>
			</div>
		</div>
	);
};

export default SearchDropDown;
